import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AlertModule, ButtonModule, CheckboxModule, TextfieldModule } from '@ed---interne/ng-uui-components';
import { NgxsModule } from '@ngxs/store';
import { EnergyActivateConsentComponent } from '../cil/energy/energy-activate-consent/energy-activate-consent.component';
import { EnergyService } from '../cil/energy/energy.service';
import { PublicState } from '../state/public.state';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ConsentEnergyComponent } from './consent-energy/consent-energy.component';
import { DenyEnergyComponent } from './deny-energy/deny-energy.component';
import { ErrorComponent } from './error/error.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { PublicRoutingModule } from './public-routing.module';
import { PublicComponent } from './public.component';
import { PublicService } from './public.service';
import { SignupComponent } from './signup/signup.component';

@NgModule({
  imports: [
    CommonModule,
    PublicRoutingModule,
    ReactiveFormsModule,
    TextfieldModule,
    CheckboxModule,
    AlertModule,
    ButtonModule,
    EnergyActivateConsentComponent,
    NgxsModule.forFeature([PublicState]),
  ],
  declarations: [
    PublicComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    LoginComponent,
    SignupComponent,
    ErrorComponent,
    ConsentEnergyComponent,
    DenyEnergyComponent,
  ],
  providers: [PublicService, EnergyService],
  bootstrap: [PublicComponent],
})
export class PublicModule {}
